/**
 * T107: Settings Index Route
 * Route for settings overview page
 */

import { createFileRoute } from '@tanstack/react-router'
import { SettingsIndexPage } from '@/pages/settings/settings-index'

export const Route = createFileRoute('/_authenticated/settings/')({
  component: SettingsIndexPage,
})
